import React, { useEffect, useRef, useState } from 'react';
import './QuoteBanner.css';

/* ─── Quote bank ─────────────────────────────────────────────── */
const QUOTES = [
  { q: '“It’s not weak to speak.”',                         a: '— Movember Foundation' },
  { q: '“Real strength is vulnerability.”',                a: '— Brené Brown' },
  { q: '“Strong men ask for help.”',                       a: '— Anonymous' },
  { q: '“You are not your struggles.”',                    a: '— Unknown' },
  { q: '“Healing starts with a conversation.”',            a: '— Man of Valor' },
  { q: '“Talk about it. Silence kills.”',                  a: '— Man of Valor' }
];

/* Random helper ------------------------------------------------ */
const randomItem = arr => arr[Math.floor(Math.random() * arr.length)];

export default function QuoteBannerPlus() {
  const [visible, setVisible]     = useState(false);
  const [quoteObj]                = useState(() => randomItem(QUOTES));
  const [animation]               = useState(() => randomItem(['typing', 'slide', 'zoom']));
  const [typedText, setTypedText] = useState('');
  const [typingDone, setTypingDone] = useState(false);

  const bannerRef = useRef(null);

  /* Intersection trigger */
  useEffect(() => {
    const io = new IntersectionObserver(
      ([e]) => e.isIntersecting && setVisible(true),
      { threshold: 0.25 }
    );
    if (bannerRef.current) io.observe(bannerRef.current);
    return () => io.disconnect();
  }, []);

  /* Typing effect -------------------------------------------------- */
  useEffect(() => {
    if (!visible || animation !== 'typing') return;

    let i = 0;
    const step = () => {
      setTypedText(quoteObj.q.slice(0, i + 1));
      i += 1;
      if (i < quoteObj.q.length) {
        setTimeout(step, 25);      // typing speed (ms per char)
      } else {
        setTypingDone(true);
      }
    };
    step();
  }, [visible, animation, quoteObj.q]);

  const displayedQuote = animation === 'typing' ? typedText : quoteObj.q;

  return (
    <section
      ref={bannerRef}
      className={`quote-banner quote-banner--${animation} ${
        visible ? 'quote-banner--visible' : ''
      }`}
    >
      <p className="quote-banner__text">{displayedQuote}</p>
      {(animation !== 'typing' || typingDone) && (
        <p className="quote-banner__author">{quoteObj.a}</p>
      )}
    </section>
  );
}
